import { CHAT_FLOW_STEPS, ChatAPI } from '@guuru/chat-web';
import { PRIORITIES } from '@guuru/expert-common';
import { client } from '@guuru/graphql-web';
import { i18n } from '@guuru/translation-web';
import IS_ADVICE_QUESTION from './queries/IsAdviceQuestion';

export default {
  validate() {
    const { priority } = ChatAPI.storeRetrieveParams();
    return ![PRIORITIES.bot.value, PRIORITIES.guurusOnly.value].includes(
      priority,
    );
  },

  async render(partnerId) {
    const question = ChatAPI.storeRetrieveQuestion();
    const { data: { partner: { isAdviceQuestion } = {} } = {} } =
      await client.query({
        query: IS_ADVICE_QUESTION,
        variables: {
          partnerId,
          question,
          languageCode: i18n.language,
        },
      });

    if (isAdviceQuestion) {
      ChatAPI.storeChatPriority(PRIORITIES.guurusOnly.value);
      return { goToStep: CHAT_FLOW_STEPS.requestCategory };
    }

    return { goToNextStep: true };
  },
};
